<template>
  <HpsfirProDrawer
    v-model:open="visible"
    :title="`${storeName} - 统计详情`"
    width="80vw"
    max-width="1200px"
    content-class="business-table-drawer"
    body-class="business-table-drawer__body"
  >
    <HpsfirProTable
      v-if="visible"
      ref="tableRef"
      export-file-name="门店统计详情"
      title=""
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"
      :loading="loading"
      row-key="id"
      :codition-init-values="conditionsInitValue"
    />
  </HpsfirProDrawer>
</template>

<script lang="ts" setup>
import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

const visible = ref(false);
const loading = ref(false);
const tableRef = ref<any>();
const storeId = ref<number>(0);
const storeName = ref('');

const conditionsInitValue = {
  dateRange: [
    dayjs()
      .subtract(7, 'day')
      .format('YYYY-MM-DD'),
    dayjs()
      .format('YYYY-MM-DD'),
  ],
};

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([
  {
    name: 'dateRange',
    label: '时间范围',
    type: 'datepick',
    pickType: 'daterange',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期',
    fastPick: [
      {
        name: '近7日',
        handler: (formdata) => {
          formdata.dateRange = [
            dayjs().subtract(6, 'day')
              .format('YYYY-MM-DD'),
            dayjs().format('YYYY-MM-DD'),
          ];
        },
        dateChangeHandler: ([start, end]) => dayjs().format('YYYY-MM-DD') === end && dayjs(end).subtract(6, 'day')
          .format('YYYY-MM-DD') === start,
      },
      {
        name: '近30日',
        handler: (formdata) => {
          formdata.dateRange = [
            dayjs().subtract(29, 'day')
              .format('YYYY-MM-DD'),
            dayjs().format('YYYY-MM-DD'),
          ];
        },
        dateChangeHandler: ([start, end]) => dayjs().format('YYYY-MM-DD') === end && dayjs(end).subtract(29, 'day')
          .format('YYYY-MM-DD') === start,
      },
    ],
    isCondition: true,
    hideTable: true,
  },
  {
    name: 'storeName',
    label: '店铺名称',
    type: 'string',
  },
  {
    name: 'syncTime',
    label: '统计日期',
    type: 'string',
  },
  {
    name: 'openCount',
    label: '开门次数',
    type: 'numberStr',
    width: 80,
  },
  {
    name: 'openPeople',
    label: '开门人数',
    type: 'numberStr',
    width: 80,
  },
]));

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const dateRange = filter.conditions.dateRange as string[] | undefined;
    const res = await useApi().storeStatisticsApi.pageStoreStatisticsstoreStatistics({
      storeId: storeId.value,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
      start: dateRange?.[0] ? dayjs(dateRange[0]).format('YYYY-MM-DD') : undefined,
      end: dateRange?.[1] ? dayjs(dateRange[1]).format('YYYY-MM-DD') : undefined,
    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const show = (row: any) => {
  storeId.value = row.id;
  storeName.value = row.name || '';
  visible.value = true;
};

defineExpose({
  show,
});
</script>

<style lang="scss" scoped>
</style>
